export default "__VITE_ASSET__Uoak$v0r__"